export const availableLanguages = [
  'en_US',
  'zh_CN',
  'zh_TW',
  'fr_FR',
  'ko',
  'ja',
  'vi',
  'th',
  'es',
  'pt',
  'pl',
  'de',
  'it',
  'fa',
  'hi',
  'ru',
]
